import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import type { Nav4DragAndDropMenuItemProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { extractHamVerticalInstantiationStatus } from '@jira/itam__tenant-context/src/extractHamVerticalInstantiationStatus.tsx';
import { extractPermissionResults } from '@jira/itam__tenant-context/src/extractPermissionResults.tsx';
import { extractWorkspaceAri } from '@jira/itam__tenant-context/src/extractWorkspaceAri.tsx';
import { useShowItam } from '@jira/itam__tenant-context/src/useShowItam.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { Nav4ITAMMenuLinkItem } from './Nav4ITAMMenuLinkItem.tsx';

export const PACKAGE_NAME = 'jiraItamNav4MenuItem';
export const TEAM_NAME = 'Aurum';

interface Props extends Nav4DragAndDropMenuItemProps {
	queryRef: {
		readonly assetsVertical_tenantContext?: Parameters<typeof extractWorkspaceAri>[0];
		readonly assetsVertical_checkPermissions?: Parameters<typeof extractPermissionResults>[0];
		readonly assetsVertical_verticalInstantiations?: Parameters<
			typeof extractHamVerticalInstantiationStatus
		>[0];
	};
}

export const Nav4ITAM = (props: Props): React.JSX.Element => {
	const assetsVerticalWorkspaceAri = extractWorkspaceAri(
		props.queryRef.assetsVertical_tenantContext,
	);
	const staticResults = extractPermissionResults(props.queryRef.assetsVertical_checkPermissions);
	const verticalInstantiationStatus = extractHamVerticalInstantiationStatus(
		props.queryRef.assetsVertical_verticalInstantiations,
	);
	const { showHardwareSettings } = useShowItam({
		assetsVerticalWorkspaceAri,
		staticResults,
		verticalInstantiationStatus,
	});

	return (
		<UFOSegment name="nav4-sidebar-itam">
			<JSErrorBoundary
				fallback="flag"
				id="itam-section"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<Nav4ITAMMenuLinkItem {...props} shouldShowHardwareSettings={showHardwareSettings} />
			</JSErrorBoundary>
		</UFOSegment>
	);
};
